import { IChangeDishPositionState } from './changeDishPositionContext';
import { ChangeDishPositionActionTypes, TChangeDishPositionActions } from './changeDishPositionActions';

export const changeDishPositionReducer = (
	state: IChangeDishPositionState,
	action: TChangeDishPositionActions,
): IChangeDishPositionState => {
	switch (action.type) {
		case ChangeDishPositionActionTypes.SET_ID_CUSTOMER:
			return {
				...state,
				IDSelectedCustomer: action.payload.IDSelectedCustomer,
				IDSelectedRestaurant: null,
				IDSelectedCategory: null,
				IDSelectedSubCategory: null,
				positionsData: [],
			};
		case ChangeDishPositionActionTypes.SET_ID_RESTAURANT:
			return {
				...state,
				IDSelectedRestaurant: action.payload.IDSelectedRestaurant,
				IDSelectedCategory: null,
				IDSelectedSubCategory: null,
				positionsData: [],
			};
		case ChangeDishPositionActionTypes.SET_ID_CATEGORY:
			return {
				...state,
				IDSelectedCategory: action.payload.IDSelectedCategory,
				IDSelectedSubCategory: null,
				positionsData: [],
			};
		case ChangeDishPositionActionTypes.SET_ID_SUB_CATEGORY:
			return {
				...state,
				IDSelectedSubCategory: action.payload.IDSelectedSubCategory,
				positionsData: [],
			};
		case ChangeDishPositionActionTypes.RESET_SELECTED_CONTROLS:
			return {
				...state,
				IDSelectedCustomer: null,
				IDSelectedRestaurant: null,
				IDSelectedCategory: null,
				IDSelectedSubCategory: null,
				positionsData: [],
			};
		case ChangeDishPositionActionTypes.SET_POSITIONS_DATA:
			return {
				...state,
				positionsData: action.payload.positionsData,
			};
		case ChangeDishPositionActionTypes.REORDER_ITEMS:
			return {
				...state,
				positionsData: action.payload.newOrder,
			};
		case ChangeDishPositionActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case ChangeDishPositionActionTypes.SET_VISIBLE_ADDITIONAL_RESTAURANTS_MODAL:
			return {
				...state,
				isVisibleAdditionalRestaurantsModal: action.payload.isVisible,
				isApplyToOne: action.payload.isApplyToOne,
				selectedAdditionalRestaurants: action.payload.selectedAdditionalRestaurants,
			};
		case ChangeDishPositionActionTypes.TOGGLE_APPLY_TO_ONE:
			return {
				...state,
				isApplyToOne: !state.isApplyToOne,
				selectedAdditionalRestaurants: [],
			};
		case ChangeDishPositionActionTypes.SET_ADDITIONAL_RESTAURANTS:
			return {
				...state,
				selectedAdditionalRestaurants: action.payload.additionalRestaurants,
			};
		case ChangeDishPositionActionTypes.SET_FETCHED_RESTAURANTS:
			return {
				...state,
				fetchedRestaurants: action.payload.fetchedRestaurants,
			};
		default:
			return state;
	}
};
